import script from "./LayersDesignFeedback.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayersDesignFeedback.vue?vue&type=script&setup=true&lang=ts"

import "./LayersDesignFeedback.vue?vue&type=style&index=0&id=d9c93c36&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9c93c36"]])

export default __exports__